module.exports = __webpack_public_path__ + "static/media/Vision_Icon.cf800f37.svg";